import { ButtonPrimary } from '@/shared/ui/button';
import styles from './index.module.sass';
import classNames from 'classnames';
import { useStore } from 'effector-react';
import { $agriculture } from '@/modules/agriculture/store/agriculture.store';
import grainIcon from '@@/mixing/images/grain.icon.svg';
import { spreadWheatType } from '@/modules/common/helpers/wheat-type.helper';

export const RecipeResultStep = ({
  specs,
  weight,
  variant,
  price,
  onClick,
  agricultureId,
  classN,
  type,
}: IRecipeResultStep) => {
  const agricultures = useStore($agriculture);
  const agriCulture = agricultures.find((item) => item.id === agricultureId);
  return (
    <div
      className={classNames(
        styles.resultStep,
        variant === 'widget' && styles.variant__widget,
      )}
    >
      <div className={styles.label}>
        <span>
          характеристики <br /> итоговой пшеницы:
        </span>
        <div className={styles.agriculture}>
          <img src={grainIcon} alt="icon" />
          <div className={styles.info}>
            <span className={styles.first}>
              {agriCulture?.name} {classN ? `, ${classN}-й класс` : ''}
            </span>
            {type && (
              <span className={styles.second}>
                {spreadWheatType(type)?.type} {spreadWheatType(type)?.sort}
              </span>
            )}
          </div>
        </div>
      </div>
      {weight && (
        <div className={styles.weight}>
          <span>вес</span>
          <div className={styles.weight__card}>{weight} т</div>
        </div>
      )}
      {price && (
        <div className={styles.price}>
          <span className={styles.price__label}>стоимость</span>
          <strong>
            {price} <span>₽</span>
          </strong>
        </div>
      )}
      <div className={styles.specs}>
        {specs.map(({ label, value, postfix }, i) => (
          <div className={styles.specs__item} key={i}>
            <span className={styles.item__label}>{label}</span>
            <span className={styles.item__value}>{value}</span>
            {postfix && postfix}
          </div>
        ))}
      </div>
      {onClick && (
        <div>
          <ButtonPrimary
            className={styles.button}
            onClick={onClick}
            label={'использовать'}
          />
        </div>
      )}
    </div>
  );
};

interface IRecipeResultStep {
  weight?: number | string;
  price?: number | string;
  variant?: 'widget';
  onClick?: any;
  agricultureId: number;
  type?: number;
  classN?: number;
  specs: {
    label: string;
    value: string | number;
    postfix: string;
  }[];
}
